import { createSlice } from '@reduxjs/toolkit';
import { addExtraReducer } from '../../utils/addExtraReducer';
import initialState from './initialState';
import {
  GetLastNotificationsReducer,
  GetNotificationsReducer,
  GetNotificationsTotalUnreadReducer,
  MarkAllNotificationsAsReadReducer,
  MarkNotificationAsReadReducer,
  MarkNotificationAsUnreadReducer,
} from './reducers';
import {
  GetLastNotifications,
  GetFactoryLastNotifications,
  GetNotifications,
  GetNotificationsTotalUnread,
  MarkAllNotificationsAsRead,
  MarkNotificationAsRead,
  MarkNotificationAsUnRead,
} from './thunks';

// ----------------------------------------------------------------------------

// slice
export const slice = createSlice({
  name: 'userNotifications',
  reducers: {},
  initialState,
  extraReducers: (builder) => {
    addExtraReducer(builder, GetNotifications, GetNotificationsReducer);
    addExtraReducer(builder, GetLastNotifications, GetLastNotificationsReducer);
    addExtraReducer(builder, GetFactoryLastNotifications, GetLastNotificationsReducer);
    addExtraReducer(builder, GetNotificationsTotalUnread, GetNotificationsTotalUnreadReducer);
    addExtraReducer(builder, MarkNotificationAsRead, MarkNotificationAsReadReducer);
    addExtraReducer(builder, MarkNotificationAsUnRead, MarkNotificationAsUnreadReducer);
    addExtraReducer(builder, MarkAllNotificationsAsRead, MarkAllNotificationsAsReadReducer);
  },
});

export default slice.reducer;
